var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagementIconAdv2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.65 39.0181V39.0681H4.7H34.05V43.2681H4.7C2.41872 43.2681 0.55 41.3566 0.55 39.0181V8.96812H4.65V39.0181ZM38.3 30.4681H38.35V30.4181V4.61812V4.56812H38.3H13.1H13.05V4.61812V30.4181V30.4681H13.1H38.3ZM13.1 0.368115H38.3C40.5813 0.368115 42.45 2.27961 42.45 4.61812V30.4181C42.45 32.7566 40.5813 34.6681 38.3 34.6681H13.1C10.8187 34.6681 8.95 32.7566 8.95 30.4181V4.61812C8.95 2.27961 10.8187 0.368115 13.1 0.368115ZM17.35 15.4181H34.05V19.6181H17.35V15.4181ZM17.35 21.8681H25.65V26.0681H17.35V21.8681ZM17.35 8.96812H34.05V13.1681H17.35V8.96812Z",
    fill: "#646AFF",
    stroke: "#F5F5F5",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementIconAdv2);
export default __webpack_public_path__ + "static/media/management-icon-adv-2.2c44b39223511f85bc3cfe0fd70a2d94.svg";
export { ForwardRef as ReactComponent };